import { Injectable } from '@angular/core';
import { ApiCallsService } from './network/api-calls.service';
import { BehaviorSubject, Observable, map, of, tap } from 'rxjs';
import { api } from 'src/app/utils/endpoints';

@Injectable({
  providedIn: 'root'
})
export class AuthPermissionsService {

  private readonly _authPermission$ = new BehaviorSubject<any>(null);
  authPermisions: Observable<any> = this._authPermission$.asObservable();

  authPermissionsList: any = [];
  constructor(private _apiCalls: ApiCallsService) { }

  getAuthPermissions() {
    this._apiCalls.get(api._permissionsAuth).subscribe({
      next: (res: any) => {
        this.authPermissionsList = res.data.rows.role_permissions.map((x: any) => x.permission.name);
        // console.log(this.authPermissionsList);
        this._authPermission$.next(this.authPermissionsList);
      },
      error: (err: any) => console.log(err)
    });
  }

  getPermissionObservers() {
    if (this.authPermissionsList.length > 0) {
      return of(this.authPermissionsList);
    } else {
      return this._apiCalls.get(api._permissionsAuth).pipe(map(res => {
        this.authPermissionsList = res.data.rows.role_permissions.map((x: any) => x.permission.name);
        console.log(this.authPermissionsList,"----permissions");
        this._authPermission$.next(this.authPermissionsList);
        return this.authPermissionsList;
      }));
    }
  }

  clearPermissions() {
    this.authPermissionsList = [];
  }
}
